//财务
import financial from '@/views/financial'
import yesSettlement from '@/views/financial/yesSettlement'
import exit from '@/views/financial/exit'
import financialDetails from '@/views/shop/orderDetails'
//财务结算申请
import settlement from '@/views/financial/settlement/applyFor'
import settlementList from '@/views/financial/settlement/list'
import allowList from '@/views/financial/settlement/allowList'
import invoiceList from '@/views/financial/settlement/invoiceList'
import fapiao from '@/views/financial/settlement/fapiao'
import invoiceDetail from '@/views/financial/settlement/invoiceDetail'
import preStorage from '@/views/financial/preStorage'


import cardorderDetail1 from '@/views/financial/cardorderDetail'
export default [
	{
	  path: '/financial',
	  name: 'financial',
		meta:[{name:'结算账单'}],
	  component: financial
	},
	{
	  path: '/financial/cardorderDetail1',
	  name: 'cardorderDetail1',
		meta:[{name:'结算账单'},{name:'结算账单详情'}],
	  component: cardorderDetail1
	},
	{
	  path: '/financial/yesSettlement',
	  name: 'yesSettlement',
		meta:[{name:'已结算账单'}],
	  component: yesSettlement
	},
	{
	  path: '/financial/yesSettlement/financialDetails',
	  name: 'financialDetails',
		meta:[
			{name:'账单'},
			{name:'账单详情'},
		],
	  component: financialDetails
	},
	{
	  path: '/financial/settlement',
	  name: 'settlement',
		meta:[{name:'结算申请'}],
	  component: settlement
	},

	{
	  path: '/financial/settlementList',
	  name: 'settlementList',
		meta:[{name:'结算记录'}],
	  component: settlementList
	},
	{
	  path: '/financial/exit',
	  name: 'exit',
		meta:[{name:'退单记录'}],
	  component: exit
	},
	{
	  path: '/financial/allowList',
	  name: 'allowList',
		meta:[{name:'可结算订单查询'}],
	  component: allowList
	},
	{
	  path: '/financial/invoiceList',
	  name: 'invoiceList',
		meta:[
			{name:'开票记录'}
		],
	  component: invoiceList
	},
  {
	  path: '/financial/preStorage',
	  name: 'preStorage',
		meta:[{name:'分销预存'}],
	  component: preStorage
	},
  
		{
		  path: '/financial/fapiao',
		  name: 'fapiao',
			meta:[
				{name:'发票信息'}
			],
		  component: fapiao
		},
		{
		  path: '/financial/invoiceDetail',
		  name: 'invoiceDetail',
			meta:[
				{name:'开票记录详情'}
			],
		  component: invoiceDetail
		},
    {
      path: '/financial/liveCard',
      name: 'liveCard',
      meta:[{name:'礼品卡销售'}],
      component: resolve =>require(['@/views/financial/liveCard'],resolve)
    },
]



// WEBPACK FOOTER //
// ./src/router/financial.js